// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Awards-module--wrapper--3pOQW","title":"Awards-module--title--146tL"};